import {CapsulableEntity, EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";
import {RouterJoyLink} from "../link.tsx";

export interface CompanyCapsuleProps extends Omit<EntityCapsuleProps, "entity"> {
    company: CapsulableEntity;
}

export function CompanyCapsule(props: CompanyCapsuleProps) {
    const {company, ...rest} = props;
    if (!company.icon) {
        company.icon = iconForEntityType("company");
    }
    const capsule = <EntityCapsule entity={company} {...rest}/>
    return company.id
        ? <RouterJoyLink to="/company/$id" params={{id: company.id}}
                             underline="hover">{capsule}</RouterJoyLink>
        : capsule;
}
